import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('validation-provider',{ref:"provider",attrs:{"slim":"","rules":_vm.rules,"name":_vm.fieldName,"vid":_vm.$attrs.vid},scopedSlots:_vm._u([{key:"default",fn:function({ errors, invalid, validated }){return [_c(VSelect,_vm._g(_vm._b({attrs:{"filled":"","error-messages":_vm.observed ? [] : errors,"error":validated && invalid,"required":_vm.required}},'v-select',_vm.attrs,false),_vm.$listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }